import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "profilePicture"
const ProfilePictureIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.75 11.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14 12.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM14.17 15.224l-.446.223c-1.141.57-2.307.57-3.448 0l-.447-.223.447-.895.448.224c.859.43 1.693.43 2.552 0l.448-.224.447.895Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3Zm3.02 7.92c-.013.159-.02.319-.02.48 0 2.982 2.239 6.6 5 6.6s5-3.618 5-6.6c0-.377-.036-.745-.104-1.1-.269-.173-.427-.208-.855-.235a4.502 4.502 0 0 1-.444-.044c-.643-.1-1.176-.401-1.704-1.005-.61.357-1.359.298-2.505.024-1.632-.392-2.545-.171-4.14 1.624l-.229.257ZM18 21s-.857-2-4.286-2h-3.428C6.857 19 6 21 6 21h12Zm-.5-11.5c.5-2.5-1.5-5-3.5-4-4-2.5-8.5 1-7.5 4.5 2.32-2.61 3.968-2.212 5.236-1.905.916.222 1.634.395 2.264-.654.93 1.55 1.476 1.585 2.113 1.626.391.025.817.053 1.387.433Z"
      />
    </svg>
  )
}
export default ProfilePictureIcon
